export default __webpack_public_path__ + "static/media/sp-option-1.17a058a1.png";